const staffMessages = {
  'staff.title': 'ユーザー管理',
  'staff.title.button.sync.authority': '権限同期',
  'staff.title.sync.authority.success': '同期が完了しました。',
  'staff.title.sync.authority.failure.403': '操作権限がありません。',
  'staff.select.default': '企業で絞り込み(デフォルト:全企業)',
  'staff.staffUpdate.accountInfo.title': '作業者情報の更新',
};
export default staffMessages;
